Controller = require 'controller'
templateHelpers = require './template-helpers'
shouldHandleClick = require 'lib/util/should-handle-click'
recup = require 'recup'
protoExtend = require 'proto-extend'
_ = require 'underscore'

module.exports = templateHelpers protoExtend recup,
  b: (onClick, args...) ->
    { attrs, contents } = @normalizeArgs(args)

    if attrs.href?
      throw Error("Can't specify an href on a `b` tag")
    attrs.href = '#'

    if attrs.onClick?
      throw Error("onClick must be a positional argument to `b`")

    { disabled } = attrs
    attrs.onClick = (e) ->
      e.preventDefault()
      if !disabled
        onClick(e.currentTarget)

    @a attrs, contents

  link: (url, args...) ->
    { attrs, contents } = @normalizeArgs(args)
    if attrs.href?
      throw Error("Can't specify an href on a `link` tag")
    attrs.href = url

    oldOnClick = attrs.onClick
    attrs.onClick = (e) ->
      if !shouldHandleClick(e)
        return
      e.preventDefault()
      oldOnClick?()
      Controller.navigate(url, trigger: true)
      return

    @a attrs, contents

  radio: (component, name, value, callback) ->
    onChange = (e) ->
      if e.target.checked
        change = {}
        change[name] = value
        component.setState change
        if _.isFunction(callback)
          callback()
      return
    checked = _.isEqual component.state[name], value

    @input { type: 'radio', name, value, checked, onChange }

  statelessRenderable: (displayName, fn) ->
    _.extend(@renderable fn, { displayName })



// WEBPACK FOOTER //
// ./app/scripts/views/internal/recup-with-helpers.coffee